import { orbitGuidancePose } from './_pure/visualGuidance.js';
export function createGuidanceOrbit(camera, center, durationMs, angleRadians, onEvent) {
    if (!Number.isFinite(durationMs) || durationMs <= 0 || !Number.isFinite(angleRadians)
        || Math.abs(angleRadians) > Math.PI || angleRadians === 0)
        throw new Error('Invalid camera orbit.');
    let initial;
    let elapsed = 0;
    let completed = false;
    let suspended = false;
    const restore = () => {
        if (!initial)
            return;
        camera.apply(initial);
        camera.setGuided(false);
        initial = undefined;
    };
    return {
        tick(deltaMs, paused, transitionActive) {
            if (completed)
                return;
            if (paused) {
                if (initial && !suspended)
                    onEvent?.('pause');
                suspended = true;
                return;
            }
            if (suspended && initial)
                onEvent?.('resume');
            suspended = false;
            if (transitionActive) {
                // Geometry camera choreography owns the camera whenever a transition begins.
                if (initial) {
                    // The transition has already staged its camera; do not overwrite that pose or control ownership.
                    initial = undefined;
                    completed = true;
                    onEvent?.('cancel');
                }
                return;
            }
            if (!initial) {
                const pose = camera.read();
                if (!pose)
                    throw new Error('Episode orbit requires a ready camera.');
                initial = pose;
                camera.setGuided(true);
                onEvent?.('start', initial);
            }
            elapsed = Math.min(durationMs, elapsed + Math.max(0, deltaMs));
            camera.apply(orbitGuidancePose(initial, center, angleRadians, elapsed / durationMs));
            if (elapsed >= durationMs) {
                restore();
                completed = true;
                onEvent?.('complete');
            }
        },
        dispose() {
            const active = initial !== undefined;
            restore();
            completed = true;
            if (active)
                onEvent?.('cancel');
        },
    };
}
